import Lottery from './index'

export default { path: '/home/activity/lottery', component: Lottery }
